module.exports = __webpack_public_path__ + "img/ecart-pay.ecbb4659.svg";